import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import BuildIcon from '@material-ui/icons/Build';
import IconButton from '@material-ui/core/IconButton';

class ComplexExpressionButton extends React.Component {

    render() {

        return (
            <Tooltip title={this.props.title}>
                <span>
                    <IconButton disabled={this.props.disabled}
                        data-test={this.props.dataTest} size="small" onClick={this.props.onClick}>
                        {this.props.icon}
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
}

ComplexExpressionButton.defaultProps = {
    icon: <BuildIcon fontSize="small" />,
    disabled: false
};

ComplexExpressionButton.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default ComplexExpressionButton;